import { Navigate } from 'react-router-dom';

import { useUserContext } from '@spacefill/shared/src/utils/contexts/UserContext';

import { getAdditionalRequestRoutes } from './routes/AdditionalRequestRoutes';
import { getAppointmentsRoutes } from './routes/AppointmentsRoutes';
import { getDashboardRoutes } from './routes/DashboardRoutes';
import { getDocumentRoutes } from './routes/DocumentRoutes';
import { getIncidentsRoutes } from './routes/IncidentsRoutes';
import { getIntegrationsRoutes } from './routes/IntegrationsRoutes';
import { getMasterItemRoutes } from './routes/MasterItemRoutes';
import { getOrderRoutes } from './routes/OrderRoutes';
import { getSettingsRoutes } from './routes/SettingsRoutes';
import { getStockSituationRoutes } from './routes/StockSituationRoutes';
import { getTransportsRoutes } from './routes/TransportRoutes';
import { getUserRoutes } from './routes/UserRoutes';

const CompanySwitcherLoader = async () =>
    import('../layout/CompanySwitcherLoader').then((module) => ({
        Component: module.CompanySwitcherLoader,
    }));
export const getLoggedUserRoutes = (user /*, features */) => {
    return [
        ...getDashboardRoutes(user),
        ...getOrderRoutes(user),
        ...getStockSituationRoutes(user),
        ...getTransportsRoutes(user),
        ...getAppointmentsRoutes(user),
        ...getDocumentRoutes(user),
        ...getIncidentsRoutes(user),
        ...getMasterItemRoutes(user),
        ...getIntegrationsRoutes(user),
        ...getAdditionalRequestRoutes(user),
        ...getSettingsRoutes(user),
        ...getUserRoutes(user),

        // Special route
        {
            path: '/admin/switch-company',
            lazy: CompanySwitcherLoader,
        },
        //  Default
        {
            path: '*',
            element: <DefaultNavigateLoggerUser />,
        },
    ];
};

const DefaultNavigateLoggerUser = () => {
    // This is the only case when we need the useUserContext out from the RouterContext,
    // because of login redirection.
    const { user } = useUserContext();
    const configurations = user?.customerWarehouseConfigurations ?? [];

    if (user?.isTransportOrdersManagementEnabled && configurations.length === 0) {
        return <Navigate to={'/transports/'} />;
    }

    if (user.role === 'PROVIDER') {
        if (configurations.length > 0) {
            if (configurations.length === 1) {
                return <Navigate to={`/logistic-management/warehouses/${configurations[0].warehouseId}/orders/`} />;
            }
            return (
                <Navigate to={user?.features?.hasAnalyticsEnabled ? '/analytics/' : '/logistic-management/orders/'} />
            );
        }
        return <Navigate to='/profile/' />;
    }
    if (user.role === 'SHIPPER') {
        if (configurations.length === 1) {
            return <Navigate to={`/logistic-management/warehouses/${configurations[0].warehouseId}/orders/`} />;
        }
        if (configurations.length > 1) {
            return (
                <Navigate to={user?.features?.hasAnalyticsEnabled ? '/analytics/' : '/logistic-management/orders/'} />
            );
        }
    }
    return <Navigate to='/company-profile/' />;
};
